"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.institutionItemTableName = exports.institutionSyncUpdateSchema = exports.institutionItemSchema = void 0;
const zod_1 = require("zod");
exports.institutionItemSchema = zod_1.z.object({
    itemId: zod_1.z.string(),
    accessToken: zod_1.z.string(),
    wizefiId: zod_1.z.string(),
    isTokenRemoved: zod_1.z.optional(zod_1.z.boolean()),
    request_id: zod_1.z.optional(zod_1.z.string()),
    lastCursor: zod_1.z.optional(zod_1.z.string()),
    needSync: zod_1.z.optional(zod_1.z.boolean()),
    lastSyncWebhook: zod_1.z.optional(zod_1.z.string()),
    lastSyncDate: zod_1.z.optional(zod_1.z.string()),
    itemName: zod_1.z.optional(zod_1.z.string()),
    // Set when the item's cursor is being held back because a Plaid batch could not be
    // fully committed (accounts still pending activation). Used to bound how long we
    // keep replaying the same batch. Cleared once the hold resolves.
    cursorHoldSince: zod_1.z.optional(zod_1.z.string()),
});
exports.institutionSyncUpdateSchema = zod_1.z.object({
    itemId: zod_1.z.string(),
    lastCursor: zod_1.z.optional(zod_1.z.string()),
    needSync: zod_1.z.optional(zod_1.z.boolean())
});
exports.institutionItemTableName = 'InstitutionItems';
